import { useEffect } from "react"
import { useTheme } from "styled-components"

const Init = () => {
  const { toggleTheme } = useTheme()

  useEffect(() => {
    window.toggleUiTheme = toggleTheme
  }, [toggleTheme])

  useEffect(() => {
    function resetHeight() {
      document.body.style.height = `${window.visualViewport?.height || window.innerHeight}px`
    }
    window.addEventListener("resize", resetHeight)
    resetHeight()
    return () => {
      window.removeEventListener("resize", resetHeight)
    }
  }, [])

  return null
}

export { Init }
